<template>
    <el-config-provider :locale="zhCn">
        <!--  v-if="_ajax.store.re_load" -->
        <router-view />
         <!-- :is-visible.sync="authStore.isLoginModalVisible" 双向绑定 -->
        <LoginModal 
            :is-visible="authStore.isLoginModalVisible"
            @loginSuccess="authStore.loginSuccess()"
        />
    </el-config-provider>
</template>
<script>
import zhCn from "element-plus/lib/locale/lang/zh-cn"
import { test } from '@/config/index';
import LoginModal from '@/components/loginModal.vue';
import { storeInit } from "@/store/index.js";

export default {
    name: 'app',
    components: { LoginModal },
    data() {
        return {
            zhCn,
            form: {},
            isRouterAlive: true,
            re_load: true,
            authStore: storeInit(),
            faviconLink: null
        }
    },
    mounted() {
        // var in_data = {
        //     ...this._ajax.get_url_argument_obj(),
        //     ...this.$route.params,
        //     ...this.$route.query,
        // }
        // if (in_data.Authorization_vcase) {
        //     sessionStorage.Authorization_vcase = in_data.Authorization_vcase
        // }
        
        // this._ajax.store.user = JSON.parse(localStorage.VCASE_user || '{"permissions_group":[]}')
        // this.infoFun()

        // 初始化favicon（页面加载时执行）
        this.updateFavicon();
        // 监听user对象中icoImage的变化（确保能捕获嵌套属性更新）
        this.$watch(
        () => this._ajax?.store?.user?.icoImage, // 监听目标：icoImage属性
        (newVal) => {
            this.updateFavicon(); // 变化时重新更新favicon
        },
        { deep: true } // 深度监听（若user是复杂对象）
        );
        
    },
    methods: {
        infoFun() {
            if (!this.$route.name) {
                return
            }
            this._ajax.post({
                url: "UserStopWep",
                data: {
                    name: this.$route.name
                },
                /*success: (res) => {
                    this._ajax.store.user = res.data
                    localStorage.VCASE_user = JSON.stringify(res.data)
                },*/
            })
            if ((sessionStorage.Authorization_vcase || localStorage.Authorization_vcase) && this.$route.name && this.$route.name != "login") {
                this._ajax.store.user = JSON.parse(localStorage.VCASE_user || "{}")
            } else if (this.$route.name && this.$route.name != "login") {
                // this.routerPush("login")
            }
        },
        updateFavicon() {
            const defaultIcon = '/static/ico.ico'; // 默认图标路径
            const userIcon = this._ajax?.store?.user?.icoImage || ''; // 用户自定义图标
            const targetHref = userIcon ? userIcon : defaultIcon; // 优先级：用户图标 > 默认图标
        
            // 情况1：已存在favicon标签，直接更新href
            if (this.faviconLink) {
                this.faviconLink.href = targetHref;
            } else {
                // 情况2：首次创建favicon标签
                this.faviconLink = document.createElement('link');
                this.faviconLink.rel = 'icon';
                this.faviconLink.type = 'image/x-icon'; // 图标类型（根据实际图标格式调整，如image/png）
                this.faviconLink.href = targetHref;
                // 将link标签添加到<head>中
                document.head.appendChild(this.faviconLink);
            }
            }
    },
    // watch: {
    //     // 调试：监控状态变化
    //     'authStore.isLoginModalVisible'(newVal) {
    //         console.log('父组件状态变化:', newVal);
    //     }
    // }
    // watch: {
    //     $route(a, b) {
    //         if (!b.name) {
    //             this.infoFun()
    //         }
    //     }
    // }
}
</script>
<style lang="scss">
</style>